import { UsersService } from './../Services/users.service';
import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  games_list:any;
  user_id:string;
  user_counter:string
   counters:any;
   count:number=8;
   users_list:any;
   user_role:string;
  constructor( private router:Router,
    private games:GamesService , private users:UsersService) {
      this.user_id=localStorage.getItem('user_id');
      this.user_role=localStorage.getItem('userRole');
      if(this.user_role=='dev'){
        this.getgames(this.user_id);
      }
      else {
      this.getgames();}
    this.games.getCounters().subscribe(
      next=>{console.log(next),
      this.counters=next},
      error=>{console.log(error)}
    )
    //get users 
    this.users.getUsers().subscribe(
      next=>{
        console.log('oioioi');
        console.log(next);
      this.users_list=next},
           error=>{
           console.log(error);
         }
        ) 
    }

  ngOnInit() {
  }

  show(game_id){
    this.router.navigate([`/gamepage/${game_id}/${this.user_id}`]);
    console.log("you addthis");
  }
  //get the list of games 
getgames(id=null){

  this.games.getgames(id).subscribe(
    next=>{
      console.log(next);
      this.games_list=next['top']}, 
    error=>{console.log(error)}
  )
}

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/home/home.component.ts